var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
import Uploader from 'uploader';
import $http from '$http';

function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

export const util = {
    DOMAIN: "http://erp.iqeq.cn", //线上站点
    DOMAIN2: "http://union.iqeq.cn", //联帮线上站点
    TEST_DOMAIN3: 'http://test2.erp.iqeq.cn',
    TEST_DOMAIN: 'http://test.erp.iqeq.cn:8089',  //测试站点test内网，test2外网测试站点
    TEST_DOMAIN2: 'http://test2.union.iqeq.cn', //联帮内网
    getDomain() {
        return this.DOMAIN;
    },
    getDomain2() {
        return this.DOMAIN2;
    },
    isEmptyObject(obj) {
        return isEmptyObject(obj);
    },
    /** 
     * 是否去除所有空格 
     * @param str 
     * @param is_global 如果为g或者G去除所有的  修改为true则为去除所有空格
     * @returns 
     */
    trimAllSpace(str, is_global) {
        var result;
        result = str.replace(/(^\s+)|(\s+$)/g, "");
        if (is_global) {
            result = result.replace(/\s/g, "");
        }
        // if (is_global.toLowerCase() == "g") {
        //     result = result.replace(/\s/g, "");
        // }
        return result;
    },
    /**
     * @表单验证
     * @rules:验证规则：[{字段名称,字段数值,规则1,规则2,规则3}]
     * {
        name: "班主任名称",
        value: this.TeacherForm.UserName,
        required: true,
        msg:""
    }
    或者
    {
        name: "班主任名称",
        value: this.TeacherForm.UserName,
        customerValidate:()=>{
            return false;
        }
    }
     */
    checkForm(options) {
        var opts = $.extend({}, {
            ele: null,
            rules: []
        }, options);
        let _this = this;
        let pFlag = true;
        let errorTip = '';

        $.each(opts.rules, function (index, item) {
            let pName = item.name;
            let pValue = item.value;
            let pMsg = $.trim(item.msg);
            $.each(item, function (name, value) {
                let flag = true;
                switch (name) {
                    case "required":
                        if (value && isArray(pValue) && pValue.length == 0) {
                            flag = false;
                            errorTip = `${pName} 不能为空！`;
                        } else if (value && $.trim(pValue).length == 0) {
                            flag = false;
                            errorTip = `${pName} 不能为空！`;
                        }
                        break;
                    case "phone":
                        if (value && !util.checkPhone($.trim(pValue))) {
                            flag = false;
                            errorTip = `${pName} 格式不正确！`;
                        }
                        break;
                    case "isNumber":
                        if (value && !util.checkNumber($.trim(pValue))) {
                            flag = false;
                            errorTip = `${pName}：请输入数字！`;
                        }
                        break;
                    case "more0":
                        if (value && !util.checkNumber2($.trim(pValue))) {
                            flag = false;
                            errorTip = `${pName}：请输入大于0的数字！`;
                        }
                        break;
                    case "customerValidate":
                        if (typeof value == "function") {
                            flag = value(pName, pValue);
                            if (!flag) {
                                errorTip = `${pName} 格式不正确！`;
                            }
                        }
                        break;
                    case "address":
                        if (value && $.trim(pValue).length < 5) {
                            flag = false;
                            errorTip = `${pName}：至少需要5个字符！`;
                        }
                        break;
                }
                if (!flag) {
                    if (pMsg.length > 0) {
                        errorTip = pMsg;
                    }
                    pFlag = false;
                    return false;
                }
            });

            if (!pFlag) {
                opts.ele.$notify({
                    title: '警告',
                    message: errorTip,
                    type: 'warning'
                });
                return false;
            }

        });

        return pFlag;
    },
    elCheckPhone(rule, value, callback) {
        if (!util.checkPhone(value)) {
            callback(new Error('请输入正确的手机号码!'));
        } else {
            callback();
        }
    },
    checkNumber(value) {
        let re = /^[0-9]*$/;
        if (!re.test(value)) {
            return false;
        }
        return true;
    },
    checkNumber2(value) {
        let re = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/;
        if (!re.test(value)) {
            return false;
        }
        return true;
    },
    checkPhone(value) {
        let mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(16[0-9]{9})$/;
        if (!mobile.test(value) || $.trim(value).length === 0 || $.trim(value).length > 11) {
            return false;
        }
        return true;
    },
    getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    /**
     * d1:"2007-2-2 7:30";
     * d2:"2007-2-2 7:30";
     * return true,false；如果d1>d2,true,否则 false
     */
    compareDate(d1, d2) {
        let date1 = (new Date(d1.replace(/-/g, "\/")).getTime());
        let date2 = (new Date(d2.replace(/-/g, "\/")).getTime());
        return (date1 > date2);
    },
    formatDate: {
        format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        }
    },
    time2str: function (tl, type) {
        var date = new Date(tl);
        var day = (date.getDate().toString());
        (day.length == 1) ? day = '0' + day: day = day;
        var mou = ((date.getMonth() + 1).toString());
        (mou.length == 1) ? mou = '0' + mou: mou = mou;
        var yea = (date.getFullYear().toString());
        var hou = ((date.getHours()).toString());
        (hou.length == 1) ? hou = '0' + hou: hou = hou;
        var min = ((date.getMinutes()).toString());
        (min.length == 1) ? min = '0' + min: min = min;
        var sen = ((date.getSeconds()).toString());
        (sen.length == 1) ? sen = '0' + sen: sen = sen;
        if (type === 'short') {
            return yea + '-' + mou + '-' + day;
        } else {
            return yea + '-' + mou + '-' + day + ' ' + hou + ':' + min + ':' + sen;
        }
    },
    str2date: function (strTime) {
        //new Date(year, month[, day[, hour[, minutes[, seconds[, milliseconds]]]]]);
        strTime = strTime.trim();
        var type = (strTime.indexOf(' ') == -1) ? "date" : "dateTime";
        var arr = strTime.split(' '),
            date,
            time,
            dateArr,
            year, month, day,
            timeArr,
            hour, minutes, seconds;

        date = arr[0];
        dateArr = date.split('-');
        year = dateArr[0];
        month = dateArr[1];
        day = dateArr[2];
        if (type === 'dateTime') {
            time = arr[1];
            timeArr = time.split(':');
            hour = timeArr[0];
            minutes = timeArr[1];
            seconds = timeArr[2];
            return new Date(year, month - 1, day, hour, minutes, seconds);
        } else {
            return new Date(year, month - 1, day);
        }
    },
    // redirect(othis, url) {
    //     redirect(othis, url, false);
    // },
    redirect(othis, url, needLogin) {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
        } else {
            othis.$notify({
                title: '错误',
                message: '验证失效，请登录重试',
                type: 'error'
            });
            return;
        }
        var redirectUrl = url;
        if (needLogin) {
            if (url.indexOf("?") > -1) {
                redirectUrl += '&Sid=' + (user.Sid || '') + '&Session=' + (user.Session || '')
            } else {
                redirectUrl += '?Sid=' + (user.Sid || '') + '&Session=' + (user.Session || '')
            }
        }
        othis.$router.push(redirectUrl);
    },
    getSessin() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            return [user.Sid || '', user.Session || ''];
        }
        return ['', ''];
    },
    uploadPicture(othis, flag) {

        var _this = othis; //指向upload实例
        othis.$nextTick(function () {
            var accessid = 'wKoXc1dyT1cYDBPN';
            var accesskey = 'LeXHaVXwKFppzaBywBeA4tVKVNEJ6s';
            var host = 'http://zqres.oss-cn-hangzhou.aliyuncs.com';

            var time = new Date(),
                timestamp, suffix;
            var d = time.getFullYear() + "/" + (time.getMonth() + 1) + "/" + time.getDate() + '/';
            var g_dirname = 'webapires/ol/' + d;
            var g_object_name = '';
            var g_object_name_type = 'random_name';
            var g_ali_dirname = 'http://resimg.iqeq01.com/';
            var now = timestamp = Date.parse(time) / 1000;

            var policyText = {
                "expiration": "2050-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
                "conditions": [
                    ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
                ]
            };
            var policyBase64 = Base64.encode(JSON.stringify(policyText))
            window.message = policyBase64
            var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, {
                asBytes: true
            });
            var signature = Crypto.util.bytesToBase64(bytes);
            /*----------------*/

            var arr = {
                Name: '',
                Url: '',
                percent: '100'
            }
            const uploader1 = new plupload.Uploader({
                runtimes: 'html5,flash,silverlight,html4',
                browse_button: 'selectfiles1',
                multi_selection: false,
                container: document.getElementById('container1'),
                flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                url: 'http://oss.aliyuncs.com',
                /*     resize: { width: 80, height: 80, quality: 90 },*/
                filters: {
                    mime_types: [ //只允许上传图片和zip文件
                        {
                            title: "Image files",
                            extensions: "jpg,gif,png"
                        },

                    ],
                    max_file_size: '204800kb',
                },
                init: {
                    PostInit: function (up, files) {},

                    FilesAdded: function (up, files) {

                        plupload.each(files, function (file) {
                            /*   if(up.files.length>1) { // 最多上传1个文件
                             _this.$notify({
                             title: '提示',
                             message: "只能上传一个文件，请删除多余文件！",
                             type: 'info'
                             });
                             return;
                             }*/
                        });
                        up.start();
                    },


                    BeforeUpload: function (up, file) {

                        var len = len || 32;
                        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                        var maxPos = chars.length;
                        var pwd = '';
                        for (var i = 0; i < len; i++) {
                            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                        }


                        var pos = file.name.lastIndexOf('.')
                        suffix = ''
                        if (pos != -1) {
                            suffix = file.name.substring(pos)
                        }

                        g_object_name = g_dirname + pwd + suffix;

                        //_this.TeachingPlan = g_ali_dirname + g_object_name;

                        var new_multipart_params = {
                            'key': g_object_name,
                            'policy': policyBase64,
                            'OSSAccessKeyId': accessid,
                            'success_action_status': '200', //让服务端返回200,不然，默认会返回204
                            'signature': signature,
                        };

                        up.setOption({
                            'url': host,
                            'multipart_params': new_multipart_params
                        });

                    },

                    UploadProgress: function (up, file) {
                        _this.logining = true;
                        up.disableBrowse(true)
                    },

                    FileUploaded: function (up, file, info) {
                        if (info.status == 200) {
                            /*_this.$message({
                             showClose: true,
                             message: '上传成功'
                             });*/
                            _this.logining = false;
                            arr.Name = file.name;
                            arr.Url = g_ali_dirname + g_object_name;
                            _this.PictureList.push(arr);
                            arr = {
                                Name: '',
                                Url: '',
                                percent: '100'
                            }
                            up.disableBrowse(false)
                        } else {

                        }
                    },

                    Error: function (up, err) {
                        if (err.code == -600) {
                            _this.$message.error('文件大小不符合规范');
                        } else {
                            _this.$message.error(err.message);
                        }
                    }
                }
            });
            if (_this.flag == '1') {
                _this.flag = ''
                uploader1.init()
            }
            /*------------------*/

        });

    },
    doResult(othis, result, method, errorCallback) {
        if (result.data.StateCode !== 0) {
            if (result.data.StateCode == 99) {
                othis.$router.push('/login')
            } else {
                othis.$notify({
                    title: '错误',
                    message: result.data.StateMsg,
                    type: 'error'
                });
                if (typeof errorCallback == "function") {
                    errorCallback();
                }
            }
        } else {
            if (typeof method == "function") {
                method();
            }
        }
    },
    /**
     * 获取用户填写的查询条件
     * @param {obj} query ,查询对象
     */
    getFormSearchParams(query) {
        let param = {};
        for (let key in query) {
            if (Object.prototype.hasOwnProperty.call(query, key)) { //过滤
                if (query[key] != '' && key != 'total') {
                    param[key + ""] = query[key];
                }
            }
        }
        return param;
    },
    // 过滤json空字段
    deleteEmptyProperty(object) {

        for (var i in object) {
            var value = object[i];
            if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    if (value.length == 0) {
                        delete object[i];
                        continue;
                    }
                }
                this.deleteEmptyProperty(value);
                if (this.isEmpty(value)) {
                    delete object[i];
                }
            } else {
                if (value === '' || value === null || value === undefined) {
                    delete object[i];
                }
            }
        }
        return object
    },
    isEmpty(object) {
        for (var name in object) {
            return false;
        }
        return true;
    },
    /**
     * 重置查询对象
     * @param {obj} query ,查询对象
     */
    resetFormQueryParam(query) {
        for (let key in query) {
            if (Object.prototype.hasOwnProperty.call(query, key)) { //过滤
                if (key != "Sid" && key != "Session" && key != "pageIndex" && key != "pageSize" && key != 'total') {
                    query[key] = "";
                }
            }
        }
    },
    filterAndSetData(data, filterData) {
        let newObj = $.extend({}, {}, data);
        for (let key in filterData) {
            if (Object.prototype.hasOwnProperty.call(filterData, key)) {
                if ((key in data)) {
                    newObj[key] = filterData[key];
                }
            }
        }
        return newObj;
    },
    getMaterialByProjectName(name, list) {
        if (!isCorrectVal(name)) {
            return;
        }
        let newArr = [];
        for (let i = 0, len = list.length; i < len; i++) {
            let cell = list[i];
            if (cell.ProjectTypeName.indexOf(name) > -1) {
                newArr = (cell.ListProduct);
                break;
            }
        }
        return cloneDeep(newArr);
    },
    extendByObj(byObj, obj) {
        let obj1 = cloneDeep(byObj);
        let obj2 = cloneDeep(obj);
        for (let key in obj2) {
            if (obj1.hasOwnProperty(key)) {
                obj1[key] = obj2[key];
            }
        }
        return obj1;
    },
    getItemByIdInArr(name, arr, key) {
        if ($.trim(name).length == 0) {
            return false;
        }
        for (var i = 0; i < arr.length; i++) {
            if ($.trim(arr[i][key]).indexOf(name) > -1) {
                return arr[i];
            }
        }
        return {};
    },
    getSidAndSession(obj) {
        return {
            Sid: obj.$store.state.sysSid,
            Session: obj.$store.state.sysSession
        };
    },
    exportToFile(data, vueThis) {
        try {
            let $msg2 = vueThis.$message({
                message: '导出成功！',
                duration: 1000
            });
            var elemIF = document.createElement("iframe");
            elemIF.src = data;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        } catch (e) {
            vueThis.$notify({
                title: '浏览器不兼容，建议使用谷歌浏览器',
                type: 'error'
            });
        }
    },
    exportToFileV2(url, params, vthis) {

        //success,wrong,cry,information,refresh,loading
        jToast.show({
            type: "loading",
            text: "正在导出数据，请稍后...",
            time: -1
        });

        $http.get(url, params).then(res => {
            jToast.close();
            let {
                StateCode,
                StateMsg,
                Data,
                Cnt
            } = res.data;
            util.doResult(vthis, res, () => {
                util.exportToFile(Data, vthis);
            });
        });

    },
    // 图片上传
    initUploader(that, container, browse_button, uploadedCallback) {
        let uploaderFactory = new Uploader();
        let uploader2 = uploaderFactory.generator({
            container: container,
            browse_button: browse_button,
            multi_selection: true,
            //开始上传F
            uploadBegin: () => {},
            //上传结束并得到文件
            uploaded: (file) => {
                if (typeof uploadedCallback == "function") {
                    uploadedCallback(file);
                }
            }
        });
        uploaderFactory.init();
        return uploaderFactory;
    },
    // 文件上传，支持格式jpg,gif,png,pdf,docx,doc,xlsx
    initUploader2(that, container, browse_button, uploadedCallback) {
        let uploaderFactory = new Uploader();
        let uploader2 = uploaderFactory.generator({
            container: container,
            browse_button: browse_button,
            multi_selection: true,
            //自定义上传文件类型
            filters: {
                mime_types: [{
                    title: "Image files",
                    extensions: "jpg,gif,png,pdf,docx,doc,xlsx"
                }],
                max_file_size: '204800kb',
            },
            //开始上传F
            uploadBegin: () => {},
            //上传结束并得到文件
            uploaded: (file) => {
                if (typeof uploadedCallback == "function") {
                    uploadedCallback(file);
                }
            }
        });
        uploaderFactory.init();
        return uploaderFactory;
    }
};

export const cloneDeep = function (obj) {
    function checkObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }

    function checkArray(arr) {
        return Object.prototype.toString.call(arr) === "[object Array]";
    }
    var isObject = checkObject(obj),
        isArray = checkArray(obj);
    if (isObject) {
        var newObj = {};
        for (var key in obj) {
            newObj[key] = cloneDeep(obj[key]);
        }
        return newObj;
    } else if (isArray) {
        var newArr = [];
        for (var key in obj) {
            newArr[key] = cloneDeep(obj[key]);
        }
        return newArr;
    } else {
        return obj;
    }
};

//判断对象是否为空对象
export const isEmptyObject = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};

//判断变量是否是对象
export const isObject = function (obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
};

//判断变量是否是数组
export const isArray = function (arr) {
    return Object.prototype.toString.call(arr) === "[object Array]";
};

//判断变量是否是date对象
export const isDate = function (date) {
    return Object.prototype.toString.call(date) === "[object Date]";
};

//判断变量是否有正确的值
export const isCorrectVal = function (variable) {
    var result = true;
    if (typeof variable === "string") {
        if (variable === '' || variable === 'undefined' || variable === 'null' || variable === 'NaN' || variable === 'Infinity') {
            result = false;
        }
    } else if (typeof variable === "number") {
        if (isNaN(variable) || !isFinite(variable)) {
            result = false;
        }
    } else if (variable === null) {
        result = false;
    } else if (typeof variable === 'undefined') {
        result = false;
    } else if (isObject(variable)) {
        if (isEmptyObject(variable)) {
            result = false;
        }
    } else if (isArray(variable)) {
        if (variable.length === 0) {
            result = false;
        }
    }
    return result;
};

export const lg = function (value) {
    console.log(JSON.stringify(value));
};


// WEBPACK FOOTER //
// ./src/common/js/util.js